import {getQueryStringObject} from '../../_web/utils/url'
import {getBovioApiKey} from '../../booking/utils'
import {BrandCode} from '../../brand/types'
import {UrlCheckoutParamsType} from '../../utils/url/types/UrlParams'
import {OfferCheckApiRequestParams} from '../types/OfferCheck'

export interface OfferCheckUrlParams extends UrlCheckoutParamsType {
  searchId: string
  offerCheckedIn?: string
  pc?: string
  label?: string
}

/**
 * Default headers used for BOFH API requests.
 */
const bofhDefaultHeaders = {
  Accept: 'application/json',
  'X-Client-User-Agent': `checkout/${process.env.NEXT_PUBLIC_APP_VERSION}`
}

export default bofhDefaultHeaders as {
  Accept: 'application/json'
  'X-Client-User-Agent': string
  'x-auth-token'?: string
}

/**
 * Constructs the request parameters for the offer check API.
 * Merges default headers with custom headers and retrieves the experiment API key.
 *
 * @param url - The API endpoint URL.
 * @param brandCode - The brand code for the request.
 * @param appEnv - The application environment.
 * @param headers - Optional custom headers to include in the request.
 *
 * @returns The request parameters for the offer check API.
 *
 * @example
 * getOfferCheckApiRequestParams('https://api.example.com/check', 'brandA', 'production')
 * // {
 * //   url: 'https://api.example.com/check',
 * //   experimentApiKey: 'some-api-key',
 * //   headers: { ...defaultHeaders }
 * // }
 */
export const getOfferCheckApiRequestParams = (
  url: string,
  brandCode: BrandCode,
  appEnv: string,
  headers?: Record<string, string>
): OfferCheckApiRequestParams => ({
  url,
  experimentApiKey: getBovioApiKey({
    brandCode,
    appEnv,
    urlParams: getQueryStringObject()
  }),
  headers: {
    ...bofhDefaultHeaders,
    ...headers
  }
})
